import { getDocument, getWindow } from "@zag-js/dom-query";
import { isNil } from "lodash-es";

// !! This is a copy of the `autoResizeInput` function from `@zag-js/dom-query` with modifications to use `innerText`
// instead of `innerHTML` due to XSS issues.

const getVisualStyles = (node: HTMLElement) => {
  const style = getComputedStyle(node);
  return (
    "box-sizing:" +
    style.boxSizing +
    ";border-left:" +
    style.borderLeftWidth +
    " solid red;border-right:" +
    style.borderRightWidth +
    " solid red;font-family:" +
    style.fontFamily +
    ";font-feature-settings:" +
    style.fontFeatureSettings +
    ";font-kerning:" +
    style.fontKerning +
    ";font-size:" +
    style.fontSize +
    ";font-stretch:" +
    style.fontStretch +
    ";font-style:" +
    style.fontStyle +
    ";font-variant:" +
    style.fontVariant +
    ";font-variant-caps:" +
    style.fontVariantCaps +
    ";font-variant-ligatures:" +
    style.fontVariantLigatures +
    ";font-variant-numeric:" +
    style.fontVariantNumeric +
    ";font-weight:" +
    style.fontWeight +
    ";letter-spacing:" +
    style.letterSpacing +
    ";margin-left:" +
    style.marginLeft +
    ";margin-right:" +
    style.marginRight +
    ";padding-left:" +
    style.paddingLeft +
    ";padding-right:" +
    style.paddingRight +
    ";text-indent:" +
    style.textIndent +
    ";text-transform:" +
    style.textTransform
  );
};

const createGhostElement = (doc: Document) => {
  const el = doc.createElement("div");
  el.id = "ghost";
  el.style.cssText =
    "display:inline-block;height:0;overflow:hidden;position:absolute;top:0;visibility:hidden;white-space:nowrap;";
  doc.body.appendChild(el);
  return el;
};
const autoResizeInput = (input: HTMLInputElement) => {
  const doc = getDocument(input);
  const win = getWindow(input);
  const ghost = createGhostElement(doc);
  const cssText = getVisualStyles(input);
  if (!isNil(cssText)) {
    ghost.style.cssText += cssText;
  }
  const resize = () => {
    win.requestAnimationFrame(() => {
      ghost.innerText = input.value; // Only relevant change compared to the Zag version
      const rect = win.getComputedStyle(ghost);
      input?.style.setProperty("width", rect.width);
    });
  };
  resize();
  input?.addEventListener("input", resize);
  input?.addEventListener("change", resize);
  return () => {
    doc.body.removeChild(ghost);
    input?.removeEventListener("input", resize);
    input?.removeEventListener("change", resize);
  };
};

export default autoResizeInput;
